import React from 'react';
import InputHint from '@/components/form/base/InputHint.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import { UseFormRegisterReturn } from 'react-hook-form';
import PrimitiveCheckbox from '@/components/form/_primitives/PrimitiveCheckbox.tsx';
import { cn } from '@/lib/utils.ts';

const CheckboxInput = ({
  label,
  register,
  error,
  hint,
  disabled = false,
  className,
  required = false,
  onChange,
}: {
  label: React.ReactNode;
  register: UseFormRegisterReturn;
  error?: string;
  hint?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <div className={cn('flex flex-col', className)}>
      <div className="flex flex-row items-start justify-start gap-2">
        <PrimitiveCheckbox
          id={register.name}
          disabled={disabled}
          {...register}
          onChange={(e) => {
            register.onChange(e);
            if (onChange) {
              onChange(e);
            }
          }}
          className="mt-0.5"
        />
        <div className="flex items-center gap-0.5">
          <label
            htmlFor={register?.name}
            className="cursor-pointer text-sm font-medium leading-normal"
          >
            {label}
            {required && <span className="text-error-200"> *</span>}
          </label>
        </div>
      </div>
      <div className="flex flex-col pl-6">
        {hint && <InputHint hint={hint} />}
        {error && <InputError error={error} />}
      </div>
    </div>
  );
};

export default CheckboxInput;
